import { useMCPConfiguration, useMCPFunctionSchema } from "./hooks";

import { useListMCPFunctions } from "@/queries/evals/useListMCPFunctions";
import { SingleSourceSelector } from "@/components/PowerBlock/Block/SourceSelectors";
import { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";

const InputDataSources = ({
  sources,

  disabled = false,
}: {
  inputDataMapping: Record<string, string>;
  sources: Record<SourceType, string[]>;
  handleInputDataChange: (key: string, source: string | undefined) => void;
  disabled?: boolean;
}) => {
  const { serverUrl, headers, functionName } = useMCPConfiguration();

  const functionsQuery = useListMCPFunctions(serverUrl, headers);
  const { mcpSchema } = useMCPFunctionSchema(functionsQuery.data, functionName);

  return (
    <div className="space-y-4">
      {mcpSchema?.properties &&
        Object.keys(mcpSchema.properties).map(key => (
          <SingleSourceSelector
            key={key}
            name={`{${key}}`}
            sources={sources}
            sourceKey={`input_data.${key}`}
            validation={{
              isValid: true,
              message: "Input data mapping is optional",
            }}
            disabled={disabled}
          />
        ))}
    </div>
  );
};

export default InputDataSources;
